import { h, Component } from 'preact';

class Modal extends Component {
    constructor() {
        super();
        this.state = {
            wModalAnimationClassName: '',
            wModalContentAnimationClassName: ''
        };
    }

    openModal() {
        this.setState({
            wModalAnimationClassName: 'w-modal-fade-in',
            wModalContentAnimationClassName: 'w-modal-fly-in'
        });
    }

    closeModal() {
        this.setState({
            uploadStep: 'upload',
            wModalAnimationClassName: 'w-modal-fade-out',
            wModalContentAnimationClassName: 'w-modal-fly-out'
        });
        setTimeout(() => {
            this.setState({
                wModalAnimationClassName: ''
            });
        }, 250)
    }

    render({modalHeaderText, modalClass}, {wModalAnimationClassName, wModalContentAnimationClassName}) {
        return (
            <div className={`w-modal ${wModalAnimationClassName} ${modalClass}` }>
                <div className={`w-modal-overlay`}>
                </div>
                <div className={`w-modal-content ${wModalContentAnimationClassName}`}>
                    <div className={`w-modal-header`}>
                        <h3>{modalHeaderText}</h3>
                    </div>
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/scripts/views/tags/modal.js